import {
  CheckCircle,
  Clock,
  FileText,
  TrendingUp,
  XCircle,
} from "lucide-react";

/**
 * Stats cards row shown above the My-Escalations table.
 *
 * Props:
 *   stats      {object}  — { total, pending, inProgress, resolved, rejected }
 *   theme      {string}
 *   screenSize {string}
 *   styles     {object}
 *   fonts      {object}
 *   t          {object}  — text[language]
 */
const StatsGrid = ({ stats, theme, screenSize, styles, fonts, t }) => {
  const hoverOn = (e) => {
    e.currentTarget.style.transform = "translateY(-4px)";
    e.currentTarget.style.boxShadow =
      theme === "dark"
        ? "0 0.75rem 2.5rem rgba(0,0,0,0.4)"
        : "0 0.75rem 2.5rem rgba(0,0,0,0.15)";
  };
  const hoverOff = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow =
      theme === "dark"
        ? "0 0.5rem 2rem rgba(0,0,0,0.3)"
        : "0 0.5rem 2rem rgba(0,0,0,0.1)";
  };

  const cards = [
    {
      icon: <FileText size={16} />,
      label: t.totalEscalations,
      value: stats.total,
      color: "#2e7cba",
    },
    {
      icon: <Clock size={16} />,
      label: t.pendingEscalations,
      value: stats.pending || 0,
      color: "#f59e0b",
    },
    {
      icon: <TrendingUp size={16} />,
      label: t.inProgressEscalations,
      value: stats.inProgress || 0,
      color: "#3b82f6",
    },
    {
      icon: <CheckCircle size={16} />,
      label: t.resolvedEscalations,
      value: stats.resolved || 0,
      color: "#10b981",
    },
    {
      icon: <XCircle size={16} />,
      label: t.statusRejected,
      value: stats.rejected || 0,
      color: "#ef4444",
    },
  ];
  // Show only the four primary stat cards side-by-side
  const primaryCards = cards.slice(0, 4);

  return (
    <div className="nx-kpi-grid" style={styles.statsGrid}>
      {primaryCards.map((card) => (
        <div
          key={card.label}
          style={styles.statCard}
          onMouseEnter={hoverOn}
          onMouseLeave={hoverOff}
        >
          <h4
            style={{
              color: theme === "dark" ? "white" : "#1a1a1a",
              margin: "0 0 0.5rem 0",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              fontSize: fonts.body,
            }}
          >
            {card.icon}
            {card.label}
          </h4>
          <p
            style={{
              color: card.color,
              fontSize: "1.75rem",
              fontWeight: "700",
              margin: 0,
            }}
          >
            {card.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;